import type { LoadPace } from './prefs';

/*
  Холодное открытие приложения-образца (R42, spec-2 §3.2): первое за сеанс открытие идёт по шагам — права,
  код, меню, первый вид. Холст первые 400 мс пуст, дальше медальон во вкладке (StateFrame): лепесток на
  пройденный шаг. Меню приложения держит заглушку той же формы, пока не пройден шаг «Меню». Тёплое открытие
  (приложение в этом сеансе уже открывали) — без медальона, меню сразу. Настоящие шаги — зона ядра (§11).
*/

export const APP_OPEN_STEPS = ['Права доступа', 'Код приложения', 'Меню', 'Первый вид'] as const;

/** Шаг «Меню»: пока он не пройден, у меню приложения заглушка; на нём встаёт «Сбой». */
export const MENU_STEP = 2;

/**
 * Сколько идёт каждый шаг, мс; шаги в 0 мс проходят вместе с предыдущим. «Быстро» — код приезжает за
 * 300 мс, ниже порога в 400 мс: медальона нет, как раньше. «Медленно» и «Сбой» — по 600 мс на шаг.
 */
export const APP_STEP_MS: Record<LoadPace, readonly number[]> = {
  fast: [300, 0, 0, 0],
  slow: [600, 600, 600, 600],
  fail: [600, 600, 600, 600],
};

/** «Быстро»: пункты меню приезжают за 650 мс, как раньше. */
export const FAST_MENU_MS = 650;

/** Имя приложения в винительном — «Открываем «Инфраструктуру»». */
export const APP_OPEN_NAME: Record<string, string> = { 'app:infra': 'Инфраструктуру' };

/** Почему встало открытие в темпе «Сбой» и что показать поддержке. */
export const APP_OPEN_FAILURE = {
  reason: 'сервер не ответил за 30 с.',
  details: 'K-7F3A · GET /api/apps/infra/menu — 504 за 30 с',
};
